const PATIENT_ID_KEY = "patient_id";
const PATIENT_INFO_KEY = "PatientInfo";

const canUseSessionStorage = () =>
  typeof window !== "undefined" && typeof sessionStorage !== "undefined";

const safelyRemoveLocalKey = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore private-mode / disabled storage errors.
  }
};

/**
 * Patient identity must be per-tab. localStorage is shared across tabs of the
 * same origin, so writing patient_id there lets tab B overwrite tab A's patient.
 */
export const setPatientId = (patientId?: string | null) => {
  if (!canUseSessionStorage() || !patientId) return;
  sessionStorage.setItem(PATIENT_ID_KEY, String(patientId));
  safelyRemoveLocalKey(PATIENT_ID_KEY);
};

export const getPatientId = (routePatientId?: string | null): string => {
  if (routePatientId) return String(routePatientId);
  if (!canUseSessionStorage()) return "";
  return sessionStorage.getItem(PATIENT_ID_KEY) || "";
};

export const setPatientInfo = (info?: Record<string, unknown> | null) => {
  if (!canUseSessionStorage() || !info) return;
  sessionStorage.setItem(PATIENT_INFO_KEY, JSON.stringify(info));
  safelyRemoveLocalKey(PATIENT_INFO_KEY);
};

export const getPatientInfo = <
  T extends Record<string, any> = Record<string, any>,
>(): T => {
  if (!canUseSessionStorage()) return {} as T;
  try {
    return JSON.parse(sessionStorage.getItem(PATIENT_INFO_KEY) || "{}") as T;
  } catch {
    return {} as T;
  }
};
